/**
 * Stepperin puhdas askellogiikka (AB-WP6.11): askel-labelien jäsennys,
 * "completed"-seuranta ja lineaarisen navigoinnin sääntö. Ei DOMia — nämä
 * testataan suoraan; runtime.ts:n wireStepper tekee DOM- ja slot-työn.
 */

/** Jäsennä steps-JSON labeleiksi: ["A","B"] tai [{"label":"A"}]. Huono syöte → []. */
export function parseSteps(json: string): string[] {
  let parsed: unknown;
  try {
    parsed = JSON.parse(json);
  } catch {
    return [];
  }
  if (!Array.isArray(parsed)) return [];
  return parsed.map((s) => {
    if (typeof s === 'string') return s;
    if (s && typeof s === 'object' && typeof (s as { label?: unknown }).label === 'string') {
      return (s as { label: string }).label;
    }
    return '';
  });
}

/** Labeli askelelle (0-pohjainen); fallback "Step N" kun puuttuu/tyhjä. */
export function stepLabel(labels: string[], index: number): string {
  const l = labels[index];
  return l && l.trim() !== '' ? l : `Step ${index + 1}`;
}

/** Lisää askel completed-listaan (nousevasti, uniikisti); negatiivinen ohitetaan. */
export function addCompleted(completed: number[], index: number): number[] {
  if (index < 0 || completed.includes(index)) return completed;
  return [...completed, index].sort((a, b) => a - b);
}

/**
 * Saako indikaattoriklikillä siirtyä askeleeseen target (nykyisestä current)?
 * Non-lineaarinen: aina. Lineaarinen: vain taaksepäin tai nykyiseen (tulevat
 * lukossa — eteenpäin vain Next-napilla yksi kerrallaan).
 */
export function canClickTo(target: number, current: number, linear: boolean): boolean {
  if (!linear) return true;
  return target <= current;
}
